
<!-- Loading state -->
<div *ngIf="isLoading" class="loading-spinner">
  <!-- Add your loading spinner here if needed -->
</div>

<!-- Theme content - only render when data is loaded and theme is active -->
<div *ngIf="!isLoading && themeData && themeData.is_theme_active">
  
  <!-- Header username cap image -->
  <div *ngIf="themeData.header_username" 
       class="cap_img" 
       [ngStyle]="{
         'background-image': 'url(' + themeData.header_username + ')',
         'background-color': '#f0f0f0',
         'background-size': 'cover',
         'background-position': 'center',
         'background-repeat': 'no-repeat'
       }">
  </div>
  
  <!-- Header center bell/decoration image -->
  <div *ngIf="themeData.header_center" class="bell_img">
    <img [src]="themeData.header_center" 
         alt="Christmas decoration" 
         class="christmas-bell">
  </div>
  
  <!-- Lottie Animation - Tiled Pattern -->
  <!-- <div *ngIf="themeData.animation_lr" class="lottie-container">
    <lottie-player 
      *ngFor="let item of getTiledArray()"
      [src]="themeData.animation_lr"
      background="transparent"
      speed="1"
      loop
      autoplay>
    </lottie-player>
  </div> -->


    <div *ngIf="themeData.animation_lr" class="lottie-container-legacy animation_lr">
    <img [src]="themeData.animation_lr" 
         alt="animation" 
         class="christmas-bell">
  </div>

  
  
  <!-- Dynamic Falling Elements (fall_drop) - Full Screen -->
  <div *ngIf="themeData.fall_drop" class="falling-lottie-container">
    <lottie-player 
      [src]="themeData.fall_drop"
      background="transparent"
      speed="1"
      loop
      autoplay>
    </lottie-player>
  </div>





  
  <!-- Christmas header background -->
  <div *ngIf="themeData.header_bg" 
       class="christmas-header-bg" 
       [ngStyle]="{
         'background-image': 'url(' + themeData.header_bg + ')',
         'background-color': '#f8f8f8',
         'background-size': 'cover',
         'background-position': 'center',
         'background-repeat': 'no-repeat'
       }">
  </div>

  
  
</div>



<!-- Error state (optional) -->
<div *ngIf="error && !isLoading" class="error-message">
  {{ error }}
</div>


